import { cn } from "@/lib/utils";

// Visual token shared by every place that surfaces a risk synthesized from
// a v0.2 doc (legacy-mapper output). Locked in here so DetailPanel and
// RisksSheet stay consistent — picking the colour twice was a recipe for
// drift. Keep the wording short: this chip sits beside the risk content,
// not in place of it.
const LEGACY_ORIGIN_LABEL = "from v0.2";

// Slate is the "muted, needs attention but isn't itself a problem" colour
// in the rest of the UI. The chip should read as a provenance marker, not
// a severity indicator — that's why it's not red.
export const LEGACY_ORIGIN_CARD_CLASSES = "rounded-md border border-border bg-surface-tint";

export function LegacyOriginChip({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "text-[9px] uppercase tracking-wider rounded-full px-1.5 py-0.5 font-medium",
        "bg-surface-tint text-ink-subtle",
        className,
      )}
      title="This risk was synthesized from a v0.2 doc. Re-upload to add a real response."
    >
      {LEGACY_ORIGIN_LABEL}
    </span>
  );
}
